import script from "./CustomerBrandPortalTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerBrandPortalTab.vue?vue&type=script&setup=true&lang=js"

import "./CustomerBrandPortalTab.vue?vue&type=style&index=0&id=35a0af9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35a0af9b"]])

export default __exports__